export const cleanNote = (content) => {
    return content
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<iframe[^>]*>[\s\S]*?<\/iframe>/gi, '')
        .replace(/<object[^>]*>[\s\S]*?<\/object>/gi, '')
        .replace(/<meta[^>]*>/gi, '')
        .replace(/<link[^>]*>/gi, '')
        .replace(/<!--[\s\S]*?-->/g, '')
        .replace(/<[^>]*on\w+\s*=\s*["'][^"']*["'][^>]*>[\s\S]*?<\/[^>]+>/gi, '')
        .replace(/<[^>]*href\s*=\s*["']?(javascript|data):[^"'\s]+["']?[^>]*>[\s\S]*?<\/[^>]+>/gi, '')
        .replace(/<[^>]*src\s*=\s*["']?(javascript|data):[^"'\s]+["']?[^>]*>[\s\S]*?<\/[^>]+>/gi, '')
        .replace(/<[^>]*style\s*=\s*["']?([^"']*)(expression|url)[^"']*([^"']*)["']?[^>]*>[\s\S]*?<\/[^>]+>/gi, '')
        .replace(/<(\w+)[^>]*>\s*<\/\1>/g, '')
        .replace(/\s{2,}/g, ' ')
        .trim();
};
